export enum TicketTemplateBoxofficeType {
  SHEET = 'Sheet',
  PIECES = 'Pieces'
}
